import { issueTrackerConfigStyles } from "./style";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@material-ui/core";
import IssueTrackerRulesList from "./IssueTrackerRulesList/IssueTrackerRulesList";

const IssueTrackerConfig = ({ contract, handleClose, clientConfig, open }) => {
    const classes = issueTrackerConfigStyles();

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth='lg'
        >
            <DialogTitle>
                <Grid container justifyContent='space-between'>
                    <div>{`${contract?.label} SLA`}</div>
                    {contract?.headerComponent}
                </Grid>
            </DialogTitle>
            <DialogContent >
                <IssueTrackerRulesList clientConfig={clientConfig} />
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleClose}
                    className={classes.button}
                    variant="contained"
                >
                    Close
                </Button>
            </DialogActions>

        </Dialog >
    )
}
export default IssueTrackerConfig;

